export const CONFIG_WEB = {
  idbName: 'graphcache-v4', // The name of the IndexedDB database
  maxAge: 7, // The maximum age of the persisted data in days
};

export const CONFIG_NATIVE = {
  dataKey: 'graphcache-data', // The AsyncStorage key used for the data (defaults to graphcache-data)
  metadataKey: 'graphcache-metadata', // The AsyncStorage key used for the metadata (defaults to graphcache-metadata)
  maxAge: 7, // How long to persist the data in storage (defaults to 7 days)
};
